import strings from '../../../../globalization';

const BookingStatuses = [
  { label: strings.allLabel, value: -1 },
  { label: strings.statusPending, value: 0 },
  { label: strings.statusComplete, value: 7 },
  { label: strings.statusCanceled, value: 9 },
];

export { BookingStatuses };
